import React from "react";
import { motion } from "framer-motion";
import { useReducedMotionSafe } from "@/components/animation/AnimationSettings";
import { PALETTE } from "@/components/animation/MotionShared";

const STEPS = [
  { id: "perceive",   label: "PERCEIVE"   },
  { id: "plan",       label: "PLAN"       },
  { id: "act",        label: "ACT"        },
  { id: "synthesize", label: "SYNTHESIZE" },
];

export default function SignalFlowAnimation({ active = 0, testid = "signal-flow" } = {}) {
  const reduce = useReducedMotionSafe();
  const a = Math.max(0, Math.min(STEPS.length - 1, Number(active) || 0));
  return (
    <div style={S.shell} data-testid={testid}>
      <span style={S.label}>LOGIX-2™ Signal Flow</span>
      <div style={S.row}>
        {STEPS.map((step, i) => {
          const done = i <= a;
          const color = done ? PALETTE.gold : PALETTE.slate5;
          return (
            <React.Fragment key={step.id}>
              <motion.div
                style={{ ...S.node, color, borderColor: color, background: done ? `${PALETTE.gold}1a` : "transparent" }}
                animate={done && !reduce ? { boxShadow: [`0 0 0 ${color}00`, `0 0 18px ${color}66`, `0 0 0 ${color}00`] } : { boxShadow: "none" }}
                transition={reduce ? { duration: 0 } : { duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
                data-testid={`${testid}-${step.id}`}
              >
                <strong>{step.label}</strong>
              </motion.div>
              {i < STEPS.length - 1 && (
                <div style={S.linkWrap}>
                  <motion.div
                    style={{ ...S.link, background: `linear-gradient(90deg, ${color}, transparent)` }}
                    animate={reduce ? {} : { x: [-12, 12] }}
                    transition={reduce ? { duration: 0 } : { duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

const S = {
  shell: { display: "flex", flexDirection: "column", gap: 6, padding: 8, background: PALETTE.glassDark, border: `1px solid ${PALETTE.goldGlow}`, borderRadius: 10, color: PALETTE.slate3, maxWidth: "100%", boxSizing: "border-box", overflow: "hidden" },
  label: { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: "0.16em" },
  row: { display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" },
  node: { padding: "4px 9px", border: "1px solid", borderRadius: 999, fontFamily: "'Space Mono', monospace", fontSize: 10.5, letterSpacing: "0.12em", fontWeight: 800 },
  linkWrap: { flex: 1, minWidth: 18, height: 2, position: "relative", overflow: "hidden", borderRadius: 2 },
  link: { position: "absolute", inset: 0, opacity: 0.85 },
};
